<section class="hero">
    <div class="hero-inner" style="padding: 15px">
        <div class="container">
            <div class="row">
                <div class="col-xs-12">
                    <div class="hero-logo" style="margin-top: 13vh;"><img src="./assets/cls-sphere.jpg" alt="CLS Logo"
                            width="60" /></div>
                    <div>
                        <div style="margin-top: 30px;">
                            <h1 style="color: #044084;">{{ article.title }}</h1>
                            <div>
                                <h3 *ngIf="article.subtitle" style="color: #878787;">{{ article.subtitle }}</h3><button
                                    class="back-btn" (click)="backFn()">Back</button>
                                <div style="clear: both;"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="article-content-section" style="background: #d7d7d7; margin-top: 30px; padding: 15px;">
        <div class="container" style="margin-left: auto; margin-right: auto;">
            <div class="row" style="margin-left: auto; margin-right: auto;">
                <div class="col-xs-12" style="margin-left: auto; margin-right: auto;">
                    <div
                        style="padding-top: 40px; padding-bottom: 40px; max-width: 680px; margin-left: auto; margin-right: auto;">
                        <p *ngFor="let paragraph of article.content" innerHtml="{{paragraph}}"><br /></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>